import { render, staticRenderFns } from "./Funil.vue?vue&type=template&id=695b27ba&scoped=true&"
import script from "./Funil.vue?vue&type=script&lang=js&"
export * from "./Funil.vue?vue&type=script&lang=js&"
import style0 from "./Funil.vue?vue&type=style&index=0&id=695b27ba&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "695b27ba",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCard } from 'vuetify/lib/components/VCard';
import { VCardText } from 'vuetify/lib/components/VCard';
installComponents(component, {VCard,VCardText})
